import Bracket from './Bracket.vue'
import RoundRobinBracket from './RoundRobinBracket.vue'
import FreeForAllBracket from './FreeForAllBracket.vue'
import { VueConstructor } from 'vue'

export default {
  install(Vue: VueConstructor) {
    // Install a component globally
    Vue.component('tournament-bracket', Bracket)
    Vue.component('round-robin-bracket', RoundRobinBracket)
    Vue.component('ffa-bracket', FreeForAllBracket)
  }
}
